export default __webpack_public_path__ + "static/media/customActions.4fd180ea.svg";